import { Flex, Text } from "@chakra-ui/react";
import { Component, ErrorInfo, ReactNode } from "react";

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <Flex flex={1} alignItems={"center"} justifyContent={"center"}>
          <Text>We are sorry. There was an error, Please contact admin.</Text>
        </Flex>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
